import React, { useState, useEffect } from "react";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import logo from "../assets/images/logo.png";
import icon from "../assets/logos/my-icon.png";
import { Box, Text, Button, Flex, Show, Hide } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import { Link} from "gatsby";
import { BsSignpostFill, BsMailbox2 } from "react-icons/bs";
import { FaArrowRight } from "react-icons/fa";
import SocialMediaIcons from "./SocialMediaIcons";
import ContactMeModal from "./ContactMeModal";

const Navbar = () => {
  const [activeNavItem, setActiveNavItem] = useState(null);

  const activeLine = 
  <svg width="15" height="15" viewBox="0 0 161 195" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M75.8414 18.2705C75.8414 18.2705 61.8414 83.27 75.8414 186.27" stroke="#111111" stroke-width="16" stroke-linecap="round"/>
  <path d="M17.8418 108.77C59.8418 99.7705 111.342 108.77 111.342 108.77" stroke="#111111" stroke-width="16" stroke-linecap="round"/>
  <path d="M37.2871 162.855C71.8418 77.2705 152.84 8.27071 152.84 8.27071" stroke="#111111" stroke-width="16" stroke-linecap="round"/>
  <path d="M8.84096 39.7707C44.341 93.2702 143.951 177.59 143.951 177.59" stroke="#111111" stroke-width="16" stroke-linecap="round"/>
  </svg>;

  const { isOpen, onOpen, onClose } = useDisclosure();

  
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.panel');
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.left >= 0 && rect.left <= window.innerWidth) {
          setActiveNavItem(section.id);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (id) => {
    gsap.registerPlugin(ScrollToPlugin);

    const section = document.getElementById(id);
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: section.offsetLeft + (1 / 4) * section.offsetLeft },
    });
  };



  return (
    <Box
      w="full"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py="5"
      px={{base:"3",md:"10"}}
      id="navbar"
    >
      <Link to="/">
        <Show above="md">
        <img src={logo} />
        </Show>
        <Hide above="md">
        <img src={icon} style={{ marginRight: "20px"}}/>
        </Hide>
      </Link>
      <Box display="flex" gap="5" alignItems="start" fontSize={{base: "14px", md: "16px"}}>
        <Text borderRight="1px black solid" pr="3.5" onClick={() => scrollToSection("work")} cursor="pointer">
          My Work
        </Text>
        <Flex flexDir={{base: "column", md: "row"}}>
        <Text
          borderRight="1px black solid"
          pr="3.5"
          onClick={() => scrollToSection("other")}
          cursor="pointer">
          Other things
        </Text>
        {/* {
            activeNavItem === 'other' ? activeLine : ''
          } */}
        </Flex>
        <Flex direction={{base:"column", md: "row"}}>
          <Text
            borderRight="1px black solid"
            pr="3.5"
            onClick={() => scrollToSection("about")}
            cursor="pointer"
          >
            Meet me
          </Text>
          {/* {
            activeNavItem === 'about' ? activeLine : ''
          } */}
        </Flex>
        <Flex direction={{base:"column", md: "row"}}>
          <Text
            borderRight="1px black solid"
            pr="3.5"
            cursor="pointer"
          >
          <Link to="/explore">
          Explore
          </Link>
          </Text>
        </Flex>
        <Box cursor="pointer">
          <Text onClick={onOpen} cursor="pointer">Say hi</Text>
          <ContactMeModal isOpen={isOpen} onClose={onClose} />
        </Box>
      </Box>
      <Hide below="md">
      <SocialMediaIcons />
      </Hide>      
    </Box>
  );
};

export default Navbar;
